import { getStaticFilesURL } from '@noths/polaris-client-static-files';
import { css } from 'styled-components';

import type { Font } from 'client-ribbons-base/types/font';

export const getFontFormatURLs = (assetPathWithoutExtension: string) => {
  const urlWithoutExtension = getStaticFilesURL('production', assetPathWithoutExtension);

  return {
    woff2: `${urlWithoutExtension}.woff2`,
    woff: `${urlWithoutExtension}.woff`,
    ttf: `${urlWithoutExtension}.ttf`,
  };
};

export const fontFace = ({ family, formats, weight }: Font) => {
  const formatsArray = Object.entries(formats).map(
    ([format, url]) => `url('${url}') format('${format}')`,
  );

  return css`
    @font-face {
      font-family: '${family}';
      font-display: swap;
      font-style: normal;
      font-weight: ${weight};
      src: ${formatsArray.join(', ')};
    }
  `;
};
